import find from 'lodash/find'

export const mapStateToContinueOrderDetails = (state) => {
    const entities = state.entities;
    const shippingAddress = find(entities.Addresses, a => a.Id === entities.SelectedShippingAddressId);
    const billingAddress = (state.ui.useShippingForBilling)
      ? shippingAddress
      : find(entities.Addresses,
          address =>
            address.Id === entities.SelectedBillingAddressId
            && entities.BillingAddresses.includes(address.Id));
    const shippingOption = entities.ShippingOptions.filter(so => so.Id === entities.SelectedShippingOptionId)[0];
    return {
      SelectedShippingAddress: shippingAddress,
      SelectedBillingAddress: billingAddress,
        SelectedShippingOption: state.entities.CartItems.some(item => item.IsPhysical && item.IsStopWorkshop) ? state.entities.CartItems.some(item => item.IsPhysical && item.IsStopWorkshop) : shippingOption,
      Coupons: state.entities.Coupons,
      BillingEqualsShipping: state.ui.useShippingForBilling,
      Total: state.entities.Summary.Total,
      SubTotal: state.entities.Summary.SubTotal,
      PartnerIds: state.entities.Coupons.length > 0 ? state.entities.Coupons.filter(c => c.IsPartnerIdDiscount && c.Description).map(c => c.Description) : null,
      TermsAndConditions: state.ui.termsAndConditions,  
      IsPartnerIdRequired: state.entities.CartItems.some(item => item.RequiresPartnerId),
      IsShippingRequired: state.entities.CartItems.some(item => item.IsPhysical ),
        IsTermsAndConditionsRequired: state.entities.CartItems.some(item => item.IsLicense) || state.entities.CartItems.some(item => item.IsStopWorkshop),
      PaymentOptions: state.entities.PaymentOptions,
      Currency: state.entities.Summary.Currency,
        RequiredPartnerIds: state.entities.RequiredPartnerIds,
        SelectedProduct: state.entities.CartItems.length > 1 && state.entities.CartItems.some(item => item.IsStopWorkshop),
        IsStopWorkshop: state.entities.CartItems.some(item => item.IsStopWorkshop)
        
    };
}

